type SearchEvent =
  | { event: 'search_opened' }
  | {
      event: 'search_query';
      search_term: string;
      results_count: number;
    }
  | {
      event: 'search_empty';
      search_term: string;
    }
  | {
      event: 'search_result_click';
      search_term: string;
      result_href: string;
      result_title: string;
      result_position: number;
    };

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export const trackSearchEvent = (event: SearchEvent): void => {
  if (typeof window === 'undefined') return;

  if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }

  window.dataLayer.push(event);
};
